import { Add, Close, MedicalServices } from "@mui/icons-material";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Stack,
  Button,
} from "@mui/material";
import { useState } from "react";
import { useForm } from "react-hook-form";
import imgMedication from "../../../assets/medicationAux.svg";

import { isMobile } from "react-device-detect";
import { NewMedication } from "../../NewMedication";
import { useMedicationControl } from "../../../../../hooks/useMedicationControl";
import { PageHeader } from "@/components/common/PageHeader";
import { ControlPrescriptions } from "../../ControlPrescriptions";

export function ControlMedications({ open, setOpen }: any) {
  const methods = useForm({});
  const { control } = methods;
  const [openNewMedication, setOpenNewMedication] = useState(false);

  const {
    isInitialLoading,
    isRefetching,
    medications: medicationData,
    refetch: setRefetchMedication,
  } = useMedicationControl();
  return (
    <Dialog
      PaperProps={{
        sx: {
          borderRadius: "10px",
          padding: 2,
          maxWidth: "700px",
          height: isMobile ? "100%" : "fit-content",
          maxHeight: isMobile ? "none" : "600px",
        },
      }}
      fullScreen={isMobile}
      maxWidth="sm"
      fullWidth
      onClose={() => setOpen(false)}
      open={open}
    >
      <IconButton
        onClick={() => setOpen(false)}
        sx={{ position: "absolute", right: 5, top: 5 }}
      >
        <Close />
      </IconButton>

      <DialogContent>
        <Stack width="100%" spacing={2}>
          <PageHeader
            title="Meus Medicamentos"
            description="Gerencie seus medicamentos"
            icon={MedicalServices}
            action={
              <Button
                variant="contained"
                startIcon={<Add />}
                onClick={() => setOpenNewMedication(true)}
              >
                Novo Medicamento
              </Button>
            }
          />

          {openNewMedication ? (
            <NewMedication
              setModalOpen={setOpenNewMedication}
              setRefetch={() => setRefetchMedication()}
            />
          ) : (
            <ControlPrescriptions
              loading={isInitialLoading}
              data={medicationData}
              setRefetch={() => setRefetchMedication()}
              isRefetching={isRefetching}
            />
          )}
        </Stack>
      </DialogContent>
    </Dialog>
  );
}
